import { Button, Heading, Stack, Text } from '@chakra-ui/react';
import { Title } from '../../../atoms/Title';
import Cookies from 'js-cookie';

export interface IdleLoggedOutProps {
  onLoginClick: () => void;
}

const IdleLoggedOut = (props: IdleLoggedOutProps) => {
  const onLoginClick = evt => {
    evt.preventDefault();
    props.onLoginClick();
  };

  const clearCookies = () => {
    const allCookies = Cookies.get();
    Object.keys(allCookies).forEach(cookieName => {
      Cookies.remove(cookieName, { domain: window.location.hostname });
    });

    /*
      Remove after doc split release
      We now set cookies to the subdomain, but during the doc split release the browser can still have the
      old cookies with just the domain name.
      If you are reading this and the code is still here, please remove the below, it is not needed.
    */
    const regex = /^.+(\.cas-(sheild|staff)\.(net|com))$/;
    const domain = window.location.hostname;
    const superDomain = domain.match(regex)?.[1];
    Object.keys(allCookies).forEach(cookieName => {
      Cookies.remove(cookieName, { domain: superDomain });
    });
    /* END remove */
  };

  clearCookies();

  const title = 'You were logged out';

  return (
    <>
      <Title title={title} />

      <Heading as="h1" mb={6}>
        {title}
      </Heading>

      <Text fontSize="lg" mb={6}>
        To protect sensitive information, you have been logged out.
      </Text>

      <Stack spacing={3}>
        <Button as="a" href="/" variant="secondary" size="lg" onClick={onLoginClick}>
          Return to login page
        </Button>
      </Stack>
    </>
  );
};

export default IdleLoggedOut;
